import { getFormLableStyleStr } from "../FormText/FormBaseStyle";
import { getPaddingString, formFieldErrorHtml, toRGBA } from "../parser/utils";

export default ({ data, id, root }) => {
  const {
    placeholder,
    required,
    label,
    options,
  } = data;
  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;
  const labelStyle = getFormLableStyleStr(data, root.data);
  return `
    <div class="rip-field-group" style="text-align: left;${getPaddingString(
      data
    )}">
      <label style="${labelStyle}">
        ${
          required
            ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
            : ""
        }${label}
      </label>
      <div style="display: flex; gap: 8px;">
        <select
          style="
            width: 120px;
            height: 38px;
            padding: 0 8px;
            border-width: ${formBorderWidth}px;
            border-style: ${formBorderStyle};
            border-color: ${toRGBA(formBorderColor)};
            border-radius: ${formBorderRadius}px;
            color: ${toRGBA(formTextColor)};
          "
          id="${id}-code"
          name="${id}-code"
        >
          ${options.map(({label, value}) => {
            return `<option value="${value}">${label}</option>`
          })}
        </select>
        <input
          style="
            width: 100%;
            height: 38px;
            padding: 0 8px;
            border-width: ${formBorderWidth}px;
            border-style: ${formBorderStyle};
            border-color: ${toRGBA(formBorderColor)};
            border-radius: ${formBorderRadius}px;
            color: ${toRGBA(formTextColor)};
          "
          id="${id}"
          name="${id}"
          class="rip-form-input"
          placeholder="${placeholder}"
        />
      </div>
      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
